import { usePlayer } from "~/components/PlayerContext";
import rootStyles from "~/components/Root.module.scss";
import Tooltip from "~/components/Tooltip";
import styles from "~/components/player/SongRequestButton.module.scss";

interface SongRequestButtonProps {
  readonly alternate?: boolean;
}

export default function SongRequestButton(props: SongRequestButtonProps) {
  const player = usePlayer();
  const isPodcast = () => player.metadata?.program.type === "podcast";

  const anchorProps = () => {
    if (!isPodcast()) {
      return {};
    }

    return {
      "data-disabled": true,
      "aria-hidden": true,
      onClick: (event: Event) => {
        event.preventDefault();
      },
    };
  };

  return (
    <Tooltip
      content={
        isPodcast() ? "Não é possível fazer pedidos a um podcast" : "Pedido"
      }
      as="a"
      href="#song-requests"
      classList={{
        [styles.button]: true,
        [styles.alternate]: props.alternate,
      }}
      {...anchorProps()}
    >
      <IconTablerMessages />
      <span class={rootStyles["sr-only"]}>Interagir</span>
    </Tooltip>
  );
}
